import { Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/pro-regular-svg-icons";
import { useAccessibility } from "../../Store/contexts/AccessibilityContext";
import { sxTypographyAdvice, sxTypographyAdviceBold, sxTypographyAdviceTitle } from "./sxProps";
import { AdviceContainerProps } from "../../interfaces/props/AdviceContainerProps";
import { TextTypeEnum } from "../../interfaces/enum/TextTypeEnum";

const AdviceContainer = (props: AdviceContainerProps) => {
    const accessibility = useAccessibility();

    const textStyle = (textType: TextTypeEnum) => {
        switch (textType) {
            case TextTypeEnum.Regular: return sxTypographyAdvice
            case TextTypeEnum.Bold: return sxTypographyAdviceBold
        }
    }

    return (
        <div className='advice-container' style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility}}>
            <div className='advice-icon-holder'>
                <FontAwesomeIcon icon={faTriangleExclamation} className='far-triangle-exclamation'/>
            </div>
            <div className='advice-text'>
                <Typography style={accessibility.textStyleAccessibility} sx={sxTypographyAdviceTitle}>ATENÇÃO: </Typography>
                {
                    props.content.map(line =>
                        <Typography style={accessibility.textStyleAccessibility} sx={textStyle(line.type)}>{line.text}</Typography>
                    )
                }
            </div>
        </div>
    )
}

export default AdviceContainer;